import React, { useEffect } from "react";
import { EEA2Service } from "../../../../Component/Api/EmploymentEquity/WorkforceProfile_EEA2/EEA2Service";
import { DataTable } from "../../../../Component/Common/Components/DataTable/DataTable";
import { IndividualDrilldownSummaryDto } from "../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/IndividualDrilldownSummaryDto";
import { IndividualMovements } from "../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/IndividualMovements";
import { MovementTypes, UserActivityActionType } from "../../../../Component/Model/Enum/BEE123Enums";
import { EntriesPerPage } from "../../../../Component/Model/Table/Table";
import { defaultObject } from "../../../../Helpers/typescriptHelper";
import { IndividualDrilldownMapper } from "../../../Common/EEA2/IndividualDrilldownCommon";
import { IndividualModal } from "../../../Common/Individual/IndividualModal";
import { MovementsSection } from "../../../../Component/Common/Constants/UserActivityTrackingSections";
import { UserActivityService } from "../../../../Component/Api/UserActivity/UserActivityService";

interface IProps {
  scorecardId: string;
  occupationId?: number;
  raceId?: number;
  genderId?: number;
  isPermanent?: boolean | null;
  movementType: MovementTypes;
  eeOccupationId?: number;
  sourceScorecardIds?: string[];
}

export const MovementsDrilldown = (props: IProps) => {
  const [individualMovementsData, setIndividualMovementsData] = React.useState<IndividualDrilldownSummaryDto[]>(defaultObject);
  const [entriesPerPage, setEntriesPerPage] = React.useState<EntriesPerPage>({ defaultValue: 10 });
  const [pageNumber, setPageNumber] = React.useState<number>(1);
  const [filteredItemsCount, setFilteredItemsCount] = React.useState<number>(0);
  const [totalItemsCount, setTotalItemsCount] = React.useState<number>(0);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [searchValue, setSearchValue] = React.useState<string>();

  const [selectedIndividualId, setSelectedIndividualId] = React.useState<number>(0);
  const [showIndividualModal, setShowIndividualModal] = React.useState<boolean>(false);

  const entriesPerPageChanged = (entriesPerPage: number) => {
    setEntriesPerPage({ defaultValue: entriesPerPage });
    setPageNumber(1);
  };

  const pageNumberChanged = (pageNumber: number) => {
    setPageNumber(pageNumber);
  };

  const searchValueChanged = (value: string) => {
    setSearchValue(value);
  };

  const individualsSearchRequest: IndividualMovements.Request = {
    MovementType: props.movementType,
    ScorecardId: props.scorecardId,
    GenderId: props.genderId,
    IsPermanent: props.isPermanent,
    EEOccupationalLevelId: props.eeOccupationId,
    OccupationalLevelId: props.occupationId,
    RaceId: props.raceId,
    PageNumber: pageNumber,
    PageSize: entriesPerPage.defaultValue as number,
    SearchValue: searchValue,
    SourceScorecardIds: props.sourceScorecardIds,
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      let searchResult = await EEA2Service.GetIndividualMovements(individualsSearchRequest);
      if (searchResult.data) {
        setIndividualMovementsData(searchResult.data.results);
        setFilteredItemsCount(searchResult.data.filteredItemsCount);
        setTotalItemsCount(searchResult.data.totalItemsCount);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [entriesPerPage, pageNumber, searchValue]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    UserActivityService.createActivityLog({
      section: MovementsSection,
      actionType: UserActivityActionType.View,
      actionDescription: "View employee structure",
      scorecardId: props.scorecardId,
      requestUrl: window.location.href
    });
  }, []);

  const onEdit = (id: number) => {
    setSelectedIndividualId(id);
    setShowIndividualModal(true);
  };

  const closeIndividualModal = () => {
    setShowIndividualModal(false);
    setSelectedIndividualId(0);
  };

  const movementsDrilldownTableData = IndividualDrilldownMapper(individualMovementsData, onEdit);
  return (
    <>
      <div style={{ marginTop: "-32px" }}>
        <DataTable
          table={movementsDrilldownTableData}
          entriesPerPage={entriesPerPage}
          pageNumber={pageNumber}
          filteredItemsCount={filteredItemsCount}
          totalItemsCount={totalItemsCount}
          entriesPerPageChanged={entriesPerPageChanged}
          pageNumberChanged={pageNumberChanged}
          isLoading={isLoading}
          searchValueChanged={searchValueChanged}
          canSearch={true}
        ></DataTable>
      </div>
      {showIndividualModal && (
        <IndividualModal
          showIndividualModal={showIndividualModal}
          closeIndividualModal={closeIndividualModal}
          scorecardId={props.scorecardId}
          id={selectedIndividualId}
          section={MovementsSection}
        />
      )}
    </>
  );
};
